var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5692 10.236C12.4781 10.6748 11.282 10.7832 10.1297 10.5478C8.97737 10.3124 7.91966 9.74352 7.08803 8.91188C6.2564 8.08025 5.68751 7.02254 5.4521 5.87024C5.21668 4.71793 5.32511 3.52185 5.76391 2.43066C4.47172 2.95115 3.40082 3.90492 2.7348 5.12848C2.06877 6.35203 1.84911 7.76916 2.11346 9.13693C2.3778 10.5047 3.1097 11.7379 4.18368 12.6252C5.25766 13.5124 6.60684 13.9985 7.99991 14C9.19786 14 10.3684 13.6416 11.3609 12.9708C12.3535 12.3 13.1226 11.3475 13.5692 10.236Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonOutline);
export default __webpack_public_path__ + "static/media/MoonOutline.df86a5bd09a409cb5ab5756ca35a2645.svg";
export { ForwardRef as ReactComponent };